// Accordion.js
// Стили для кастомного аккордеона (Accordion) в едином месте
// Используйте этот объект для передачи в sx пропс компонентов

import { Accordion as MuiAccordion, styled } from '@mui/material';

/**
 * Accordion — universal styled accordion component for the app.
 *
 * This component is a drop-in replacement for MUI Accordion with unified styles (rounded corners, no border, no shadow).
 * All MUI Accordion props are supported.
 *
 * @component
 * @example
 * // Basic usage
 * <Accordion defaultExpanded sx={{ mb: 2 }}>
 *   <AccordionSummary expandIcon={<ExpandMoreIcon />}>Title</AccordionSummary>
 *   <AccordionDetails>Content</AccordionDetails>
 * </Accordion>
 *
 * @param {object} props - All MUI Accordion props are supported, including sx for custom styles.
 */
export const accordionStyles = {
  marginBottom: '16px',
  borderRadius: '16px',
  '&:first-of-type': {
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
  },
  border: 'none',
  '&::before': { display: 'none' },
  '&.Mui-expanded': {
    borderRadius: '16px',
  },
  boxShadow: 'none',
};

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  ...accordionStyles,
  backgroundColor: theme.palette.background.default,
}));

export default Accordion;
